module.exports = __webpack_public_path__ + "static/media/special-shapes-img.def54fa0.svg";